<template>
  <el-form
      ref="form"
      :model="form"
      :rules="rules"
      :label-position="labelPosition"
      label-width="100px"
  >
    <el-form-item
        label="机器人名称"
        prop="robitName"
    >
      <el-input
          placeholder="请输入"
          v-model="form.robitName"
      ></el-input>
    </el-form-item>
    <el-form-item
        label="描述"
        prop="desc"
    >
      <el-input
          placeholder="请输入"
          v-model="form.desc"
      ></el-input>
    </el-form-item>
    <el-form-item
        label="hook url"
        prop="hookUrl"
    >
      <el-input
          type="textarea"
          placeholder="请输入"
          v-model="form.hookUrl"
          :rows="4"
          resize="none"
      ></el-input>
    </el-form-item>
      <el-form-item
          label="secret"
          prop="secret"
      >
          <el-input
              placeholder="请输入"
              v-model="form.secret"
          ></el-input>
      </el-form-item>

    <el-form-item
      label="状态"
      prop="status"
    >
      <el-radio
        v-model="form.status"
        :label="1"
      >启用</el-radio>
      <el-radio
          v-model="form.status"
          :label="0"
      >禁用</el-radio>
    </el-form-item>
  </el-form>
</template>

<script>
import formLabalPosition from "@/mixins/formLabalPosition";
let originForm = {
  robitName: '',
  desc: '',
  hookUrl: '',
  secret: '',
  status: 1,
}
export default {
  name: "dingdingForm",
  components:{
  },
  props: {
    formData:{
      type: Object,
      default(){
        return {
          ...originForm,
        }
      }
    },
  },

  data() {
    return {
      form: {
        ...originForm,
      },
      rules:{
        robitName: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        desc:[
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        hookUrl:[
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        secret:[
          { required: true, message: '请输入', trigger: 'blur' },
        ],
      },
    }
  },
  computed: {

  },
  mixins: [formLabalPosition],
  watch:{
    formData:{
      handler(newVal,oldVal){
        if(newVal){
            this.assign(newVal);
        }
      },
      deep:true,
    },
  },
  created(){
      if(this.formData.id){
          this.assign(this.formData);
      }
  },
  methods:{
      assign(formData){
          this.form.id = formData.id;
          this.form.robitName = formData.name;
          this.form.desc = formData.desc;
          this.form.hookUrl = formData.hookUrl;
          this.form.status = formData.status;
          this.form.secret = formData.secret;
      },
    reset(){
      this.form = {
        ...originForm,
      };
    },
    validate(){
      this.$refs.form.validate((valid) => {
        if(valid){
          this.$emit('submit',this.form);
        }
      })
    },
  },
}
</script>

<style scoped>

</style>
